import { IIconBase } from '..'

const importExcelIcon = ({
  color = '#131523',
  height = 40,
  width = 41,
}: IIconBase) => {
  return (
    <svg
      width={width}
      height={height}
      viewBox='0 0 41 40'
      fill='none'
      xmlns='http://www.w3.org/2000/svg'
    >
      <path
        d='M16.0333 19.4667L20.3 23.7333L24.5667 19.4667'
        stroke={color}
        strokeWidth='1.5'
        strokeMiterlimit='10'
        strokeLinecap='round'
        strokeLinejoin='round'
      />
      <path
        d='M20.3 6.66663V23.6166'
        stroke={color}
        strokeWidth='1.5'
        strokeMiterlimit='10'
        strokeLinecap='round'
        strokeLinejoin='round'
      />
      <path
        d='M33.8333 20.3C33.8333 27.6667 28.8333 33.6334 20.5 33.6334C12.1666 33.6334 7.16663 27.6667 7.16663 20.3'
        stroke={color}
        strokeWidth='1.5'
        strokeMiterlimit='10'
        strokeLinecap='round'
        strokeLinejoin='round'
      />
    </svg>
  )
}

export default importExcelIcon
